/* scheduled banner: <div class="nemu-sched" data-from="2026/09/01 00:00:00" data-to="2026/09/30 23:59:59"> */
(function(){
  var now=Date.now();
  document.querySelectorAll('.nemu-sched').forEach(function(el){
    var f=Date.parse((el.dataset.from||'').replace(/\//g,'-')), t=Date.parse((el.dataset.to||'').replace(/\//g,'-'));
    if(!(now>=f&&now<=t)) el.remove();
  });
  /* modal: button[data-modal="#id"] */
  document.querySelectorAll('[data-modal]').forEach(function(b){
    b.addEventListener('click',function(){var d=document.querySelector(b.dataset.modal); if(d&&d.showModal) d.showModal();});
  });
  document.querySelectorAll('dialog.nemu-modal .nemu-close').forEach(function(c){
    c.addEventListener('click',function(){c.closest('dialog').close();});
  });
  /* dwell reward: reveal after N minutes, like the reference's elapsed:3m */
  document.querySelectorAll('.nemu-dwell').forEach(function(el){
    var mins=parseFloat(el.dataset.after||'3');
    setTimeout(function(){var d=el.querySelector('dialog'); if(d&&d.showModal&&!d.open) d.showModal();}, mins*60000);
  });
  /* per-block view pixel -> dataLayer */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){
        window.dataLayer=window.dataLayer||[];
        window.dataLayer.push({event:'lp_block_view',block:e.target.dataset.block||e.target.id||''});
        io.unobserve(e.target);
      }});},{threshold:.4});
    document.querySelectorAll('[data-block]').forEach(function(el){io.observe(el);});
  }
})();
